module.exports = __webpack_public_path__ + "static/33-0708c94bfba80776e21a7383b6cf5147.jpg";